import moment from 'moment-timezone'

export const getMinAndMaxYear = (timezone: string) => {
  const maxYear = moment.tz(timezone).year()
  const minYear = moment.tz('2017-01-01', timezone).year()

  return { minYear, maxYear }
}
